import { render, staticRenderFns } from "./EmployeeRevertBanking.vue?vue&type=template&id=64894a14&"
import script from "./EmployeeRevertBanking.vue?vue&type=script&lang=js&"
export * from "./EmployeeRevertBanking.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeRevertBanking.vue?vue&type=style&index=0&id=64894a14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports